/**
 * class ValidatorState
 */
class ValidationResult {

  constructor(success, error) {
    this.success = success;
    this.error = error ?? '';
  }
}

export default ValidationResult;
